<template>
  <v-dialog v-model="dialog" width="60%" persistent>
    <v-card>
      <v-toolbar color="#313a46">
        <v-card-title class="text-h5 white--text">
          Logs de processamento de peças
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </v-toolbar>

      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="info"
          :items-per-page="5"
          :loading="loading"
          class="elevation-1 rounded-lg"
          :footer-props="{ itemsPerPageText: 'Linhas por página' }"
        >
          <template v-slot:[`item.usuario`]="{ item }">
            {{ item.usuario | TitleCase }}
          </template>
          <template v-slot:[`item.acao`]="{ item }">
            {{ formatActionBlock(item.acao) }}
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            {{ item.created_at | BrazilianStandardDateAndTime }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import dateMixin from "@/mixins/dateMixin";
import EmpresaFilial from "../../../../services/http/rpa/EmpresaFilial";
export default {
  mixins: [dateMixin],

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    chaveEmpresa: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      loading: false,
      info: [],
      headers: [
        {
          text: "Empresa",
          value: "nome_empresa",
          align: "center",
          sortable: true,
          filterable: true,
        },
        {
          text: "Usuário",
          value: "usuario",
          align: "center",
        },
        {
          text: "Ação",
          value: "acao",
          align: "center",
        },
        {
          text: "Data",
          value: "created_at",
          align: "center",
        },
      ],
    };
  },

  watch: {
    dialog(value) {
      if (value) {
        this.fetchLogs(this.chaveEmpresa);
      }
    },
  },

  methods: {
    async fetchLogs(chaveEmpresa) {
      try {
        this.loading = true;
        const { data } = await EmpresaFilial(chaveEmpresa).show({
          includes: "logsBloqueiosPecas",
        });

        this.info = data.logs_bloqueios_pecas;

        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    formatActionBlock(action) {
      const statusBlock = {
        S: "Ativou",
        N: "Desativou",
      };

      return statusBlock[action] || "falha ao exibir";
    },

    checkUsuario(user) {
      if (user != null) {
        return user;
      }
      return "Usuário não informado";
    },

    closeDialog() {
      this.$emit("close");
    },
  },
};
</script>

<style></style>
